import Apiv3 from '../api/apiv3'

export const getPageWidgets = async (loja_id, pathname) => {
  const resp = await Apiv3.get('/web/page', { params: { loja_id, slug: pathname } })
  return resp
}
